module.exports = __webpack_public_path__ + "img/icon4.30539157.30539157.svg";